<template>
	<!-- LIST -->
	<div v-if="currentMode == 'list'" class="table-component-root">
		<div v-if="Data" class="table-wrapper" :class="{ 'inner-forms': isInnerForms }">

			<h4 v-if="!isInnerForms">{{ Data.title | ftc }}</h4>

			<!-- блок быстрого поиска -->
			<div class="search-wrapper">
				<Field
					:isVisibleRow="true"
					:crud="crud"
					action="list"
					name="fastSearch"
					ref="fastSearch"
					v-model="fastSearchValue"
					:Field="{ _field_name: 'fastSearch', type: 'text', title: 'main/all_fields_search', '_visible': true }"
					:removeRightPadding="true"
					:clearButton="true" @event_ClearButtonClicked="fastSearchEvent"
					:fieldInModal="inModal"
					@fastSearchInput="fastSearchEvent" />
			</div>
			<!-- ========================================== -->

			<!-- кнопка создания записи -->
			<span @click.capture="buttonClicked">
				<template v-if="isInnerForms && urlCreate">
					<button class="btn btn-submit" :title="'main/create' | ftc" @click="showInnerForm('create')">
						<font-awesome-icon icon="plus" />
						<template v-if="createButtonTitle">{{ createButtonTitle | ftc }}</template>
						<template v-else>{{ 'dns/create_title' | ftc }}</template>
					</button>
				</template>
				<template v-else>
					<router-link v-if="urlCreate"
						class="btn btn-submit font-weight-400"
						:disabled="!canShowButton"
						:title="'main/create' | ftc"
						:to="urlCreate">
						<font-awesome-icon icon="plus" />
						<template v-if="createButtonTitle">{{ createButtonTitle | ftc }}</template>
						<template v-else>{{ 'dns/create_title' | ftc }}</template>
					</router-link>
				</template>
			</span>
			<br><br>
			<!-- ========================================== -->


			<!-- главная таблица -->
			<table v-if="Data.order" class="table-component">
				<thead>
					<tr v-if="Rows && Rows.length">
						<th v-for="(column, cIdx) in Data.order" v-if="columns[column]" :style="columns[column] && columns[column].style ? columns[column].style : null" :key="cIdx">
							<span class="w5-column-sort" @click="sortTable(column)">{{ column === 'dns_priority' ? '' : ColumnsHeaders[column] | ftc }}</span>
						</th>
						<th class="column-oper"></th>
					</tr>
					<tr v-else>
						<!-- если таблица пустая -->						
						<th :colspan="Object.keys(columns).length + 1" class="text-center"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="row in Rows" :key="'row-' + row[idColumns]">
						<td v-for="(column, cIdx) in Data.order"
							:class="cellClass(column)"
							v-if="columns[column]"
							:aria-label="ColumnsHeaders[column] | ftc"
							:key="cIdx">
							<span class="w5-table-cell">
								<span v-highlightFastSearch="fastSearchValue">{{ cellValue(column, columns[column], row) }}</span>
							</span>
						</td>
						<td>
							<span @click.capture="buttonClicked">
								<template v-if="isInnerForms && urlUpdate">
									<span
										v-if="canAction('update', row) && canShowButton"
										:title="'main/edit' | ftc"
										@click="showInnerForm('update', row)">
										<font-awesome-icon icon="pencil-alt" />
									</span>
								</template>
								<template v-else>
									<router-link
										v-if="canAction('update', row) && canShowButton"
										:title="'main/edit' | ftc"
										:to="'/' + crud + '/update/' + row[idColumns]">
										<font-awesome-icon icon="pencil-alt" />
									</router-link>
								</template>
							</span>
							<font-awesome-icon v-if="canAction('delete', row) && canShowButton"
								:title="'main/delete' | ftc"
								icon="trash-alt"
								@click="() => askForDelete(row)"
							/>
						</td>
					</tr>

					<!-- если таблица пустая -->
					<tr v-show="Rows && Rows.length === 0">
						<td :colspan="Object.keys(columns).length + 1" class="text-center">
							<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
							<br>
							<span class="font-size-110 w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
						</td>
					</tr>
				</tbody>
			</table>
			<!-- ========================================================================= -->


			<!-- блок количества найденых записей и выбора количества записей на страницу -->
			<div v-if="Rows && Rows.length" class="margin-15-0">
				<!-- Найдено -->
				<span class="font-size-80 font-weight-500">{{ 'main/list_total' | ftc }}: </span>
				<span class="font-size-80">{{ Data.totalCount }}</span>

				<!-- Выбор -->
				<span class="widget-page-size">
					<span class="font-size-80 font-weight-500">{{ 'main/list_size' | ftc }}: </span>
					<span v-for="(size, sIdx) in Config.pageSizes"
						@click="setPageSize(size)"
						:class="{ 'w5-link': size !== Data.pageSize, 'font-weight-500': size === Data.pageSize }"
						class="font-size-80"
						:key="sIdx">
						&nbsp;{{ size }}&nbsp;
					</span>
				</span>
			</div>
			<!-- ========================================================================= -->


			<!-- блок пагинации -->
			<div v-if="Rows && Rows.length && paginationPages.length > 0">
				<ul class="pagination">
					<li v-for="(pg, idx) in paginationPages" :key="'li-' + idx">
						<span
							:class="{ 'first': idx === 0, 'active': pg == page, 'last': idx === paginationPages.length - 1 }"
							@click="() => setCurrentPage(pg)">
							{{ pg }}
						</span>
					</li>
				</ul>
			</div>
			<!-- ======================================== -->
			

			<!-- диалог удаления записи -->
			<transition name="modal">
				<div v-show="showDeleteModal" @click="hideDeleteModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'main/deleting' | ftc }}</span>
								<button type="button" class="close" @click="hideDeleteModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body"><p class="padding-0-5" v-withSafeTags="deleteModalText"></p></div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" @click="deleteModalStart">{{ 'main/delete' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>
			<!-- ======================================== -->

		</div>
		<div v-else>
			<!-- блок с сообщением об ошибке -->
			<transition name="fadeControl" key="transitionError">
				<div v-show="errorGotData" class="alert alert-danger font-size-90 margin-top-15" role="alert" style="margin-right: 10px">
					<button @click="errorGotData = null" class="close" :title="'main/close' | ftc">×</button>
					<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(errorGotData)"></span>
				</div>
			</transition>
		</div>
	</div>
	<!-- CREATE or UPDATE -->
	<div v-else-if="currentMode == 'create' || currentMode == 'update'" class="table-component-root">

		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="innerFormErrorMessage !== ''" class="alert alert-danger font-size-90 margin-top-15" role="alert" style="margin-right: 10px">
				<button @click="innerFormErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(innerFormErrorMessage)"></span>
			</div>
		</transition>

		<!-- форма -->
		<form v-if="innerFormData && innerFormData.fields" class="w5-from" :class="{ 'form-with-divider': isFormWithDivider }" autocomplete="off" style="margin-top: 10px"><fieldset :disabled="form_Loading">

			<!-- поля -->
			<div v-for="(row, index) in innerFormData.fields"
				v-if="row"
				:key="index"
				:class="{
					'w5-form-row': isVisibleField(row),
					'divider-field': isDividerField(row)
				}">
				<Field v-for="field in row"
					:key="field._field_name"
					:ref="field._field_name"
					:isVisibleRow="isVisibleField(row)"
					:countVisibleFieldsInRow="countVisibleFieldsInRow(row)"
					:objID="IDColumn"
					:crud="crud"
					:action="currentMode"
					:Field="field"
					:fieldInModal="inModal"

					v-model="field.value"
					@valueChanged="fieldChanged(field)"
					@blur="onBlur(field)"
					@focus="onFocus(field)"
					@blockFormButton="blockFormButton"
					@unblockFormButton="unblockFormButton"
					@enterKeyDown="onEnterKeyDown" />
			</div>

			<!-- кнопка -->
			<div class="w5-field form-button" :class="{ 'margin-top-30': isFormWithDivider }">
				<button
					type="button"
					ref="cancel_button"
					@click="closeParentModal"
					:disabled="buttonBlock > 0 ? 'disabled' : false"
					class="btn btn-default"
					:class="{ hidden: form_Loading }"
					style="width: 30%">
					{{ 'main/cancel' | ftc }}
				</button>
				<button
					type="button"
					ref="submit_button"
					@click="submitInnerForm"
					:disabled="buttonBlock > 0 ? 'disabled' : false"
					class="btn btn-submit btn-primary"
					:class="{ hidden: form_Loading }"
					style="width: 30%; float: right">
					{{ currentMode === 'update' ? 'main/save' : 'main/create' | ftc }}
				</button>
			</div>

		</fieldset></form>
	</div>
	<!-- DELETE -->
	<div v-else-if="currentMode == 'delete'">
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="innerFormErrorMessage !== ''" class="alert alert-danger font-size-90 margin-top-15" role="alert" style="margin-right: 10px">
				<button @click="innerFormErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(innerFormErrorMessage)"></span>
			</div>
		</transition>

		<div class="w5-form-del-row">
			<p style="padding: 0; margin: 0" v-withSafeTags="deleteModalText"></p>
		</div>

		<span :disabled="!canShowButton" class="btn btn-submit btn-submit-danger pull-right" @click="deleteInnerForms">{{ 'main/delete' | ftc }}</span>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '@/bus.js'
import debounce from 'debounce'
import Helper from '@/helper/helper'
import Field from '@/components/elements/formfield'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'Table',
	//=========================================================================
	// свойства компонента
	//=========================================================================
	props: [
		'crud',
		'access',
		'url-list',
		'url-create',
		'url-update',
		'columns',
		'id-columns',
		'create-button-title',
		'inner-forms',
		'in-modal',
		'crud-search-model'
	],
	//=========================================================================
	// внутренние свойства компонента
	//=========================================================================
	data() {
		return {
			// режим форсм
			isInnerForms: false,
			// данные текущей формы
			innerFormData: null,
			// заголовок для списка - кешируем
			innerFormTitleForList: '',
			// сообщение об ошибке в формк
			innerFormErrorMessage: '',
			// признак сабмита формы
			isFormSubmited: false,
			// хендлеры запросов проверяющих поле
			verifyRequestsHandlers: [],
			// блокиовка кнопки формы
			buttonBlock: 0,
			// данные в виде FormData
			FD: false,
			FD_count: 0,

			// ID редактируемой записи
			updatedRowId: '',

			// текущий режим
			currentMode: '',

			// доступ от родителя
			Access: false,

			// кеш данных
			Data: null,
			// ошибка если данные не получены
			errorGotData: null,

			// быстрый поиск
			fastSearchValue: '',

			// колонка по которой отсортирована таблица
			sortedColumn: false,

			// флаг показа конопок операци
			canShowButton: true,

			// диалог удаления записи
			showDeleteModal: false,
			deleteId: null,
			deleteModalText: '',

			// текущая страница в пагинаторе
			page: 1,
			// страницы в пагинаторе
			paginationPages: [],
			// последняя страница
			lastPage: 1,

			// строки таблицы
			Rows: []
		}
	},
	//=========================================================================
	// вычисляемые свойства компонента
	//=========================================================================
	computed: {
		//---------------------------------------------------------------------
		// конфигурация
		//---------------------------------------------------------------------
		Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig
			else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig
			else return false
		},
		//---------------------------------------------------------------------
		// название колоноки первичного ключа ID
		//---------------------------------------------------------------------
		IDColumn() {
			return this.idColumns ? this.idColumns : this.crud + '_id'
		},
		//---------------------------------------------------------------------
		// заголовки колонок
		//---------------------------------------------------------------------
		ColumnsHeaders() {
			return this.Data && this.Data.columns ? this.Data.columns : null
		},
		//---------------------------------------------------------------------
		// есть ли в форме поля с типом "header"
		//---------------------------------------------------------------------
		isFormWithDivider() {
			// если нет вообще полей
			if (!this.innerFormData.fields) return false

			// поля есть - пробежимся по ним
			let _found = false
			this.innerFormData.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj.type === 'header' && obj._visible)
						{
							_found = true
							return true
						}
					})

					if (_found) return true
				}
			})

			return _found
		}
		//---------------------------------------------------------------------
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// текущий режим
		this.currentMode = 'list'

		// режим форм
		this.isInnerForms = this.innerForms

		// доступ
		this.Access = this.access

		// текущая страница
		this.page = this.$store.state.tableCurrentPage
		if (!this.page || this.page < 0) this.page = 1

		// бстрый поиск
		this.fastSearchEvent = debounce(this.fastSearchEvent, 500)

		// нужно самим запросить данные
		this.requestData()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
		// подписка на закрытие родительского диалога
		if (this.inModal)
		{
			EventBus.$on('w5-host-modal-close-event', this.closeParentModal)
		}
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)
		// отписка на закрытие родительского диалога
		if (this.inModal)
		{
			EventBus.$off('w5-host-modal-close-event', this.closeParentModal)
		}
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос данных для просмотра
		//---------------------------------------------------------------------
		requestData(callbackAfter) {
			// еще раз проверим URL
			if (!this.urlList) return

			// инициализация объекта параметров запроса
			let _getParams = {}
			let _model = Helper.toUpperCaseFirstSymbol(this.crud) + 'Search'
			if (this.crudSearchModel) _model = this.crudSearchModel
			_getParams[_model] = {}

			// получим данные строки быстрого поиска
			if (this.fastSearchValue !== null && this.fastSearchValue !== undefined && this.fastSearchValue !== '')
				_getParams[_model]['fast_search'] = this.fastSearchValue

			// установим колонку сортировки
			if (this.sortedColumn !== false)
				_getParams['sort'] = this.sortedColumn.charAt(0) === '+' ? this.sortedColumn.substr(1) : this.sortedColumn

			// предварительно подготовим URL
			let _url = this.urlList
			if (this.page > 1)
			{
				if (_url.indexOf('?')) _url = _url.replace('?', '/' + this.page + '?')
				else _url += '/' + this.page
			}

			// теперь точно можно делать запрос
			this.$http.get(this.APIServerUrl + _url, { params: _getParams }).then(
				// успешный ответ
				respons => {
					// получаем ответ
					let _dt = respons && respons.data && typeof respons.data === 'object' ? respons.data : false

					// ответ корректный
					if (_dt && _dt['status'] === 'ok')
					{
						// запоминаем данные
						this.Data = _dt
						// сообщим родителю о новом заголовке
						if (this.Data && this.Data.title)
						{
							this.innerFormTitleForList = this.Data.title
							this.$emit('title', this.innerFormTitleForList)
						}
						// обнулим строки
						this.Rows = []
						// в следующем тике скопируем строки - что бы они все перерисовалис снова
						// это нужно для подсветки быстрого поиска
						this.$nextTick(() => {
							this.Rows = this.Data.rows.slice()
						})

						// по умолчанию - пагинатор пустой
						this.paginationPages = []
						this.lastPage = 1
						let _total = parseInt(_dt['totalCount'])
						let _size = parseInt(_dt['pageSize'])
						// если есть еще страницы
						if (_total > _size)
						{
							// получим общее количество страниц
							let _pagesCount = Math.ceil(_total / _size)
							if (!_pagesCount || isNaN(_pagesCount) || _pagesCount < 1) _pagesCount = 1

							// если страниц больше одной
							if (_pagesCount > 1)
							{
								this.lastPage = _pagesCount

								let _begin = this.page - 3
								if (_begin < 1) _begin = 1
								let _end = this.page + 3
								if (_end > _pagesCount) _end = _pagesCount

								for (let k = _begin; k <= _pagesCount; k++)
								{
									if (k > _end) break
									this.paginationPages.push(k)
								}
							}
						}

						// вызовем колбэк
						if (callbackAfter) callbackAfter()

						// на этом все
						return
					}

					// данных нет
					this.Data = null
					// если есть ошибка
					this.errorGotData = this.formatRequestError(respons)
					// вызовем колбэк
					if (callbackAfter) callbackAfter()
				},
				// отрицательный ответ
				respons => {
					// данных нет
					this.Data = null
					// если есть ошибка
					this.errorGotData = this.formatRequestError(respons)
					// вызовем колбэк
					if (callbackAfter) callbackAfter()
				}
			)
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== this.getRealCrud(this.crud)) return

			// обновляем данные, пришедшие с сервера
			this.requestData()
		},
		//---------------------------------------------------------------------
		// пришел сигнал - хотят закрыть родительский модальный диалог
		//---------------------------------------------------------------------
		closeParentModal() {
			if (this.currentMode !== 'list')
			{
				// сообщим родителю о новом заголовке
				if (this.innerFormTitleForList)
				{
					this.$emit('title', this.innerFormTitleForList)
				}

				this.currentMode = 'list'
				this.$emit('containerClass', 'wide')
			}
		},
		//---------------------------------------------------------------------
		// выводит значение ячейки
		//---------------------------------------------------------------------
		cellValue(columnName, columnData, Row) {
			let _value = Row[columnName]
			if (columnData && columnData.formatter && typeof columnData.formatter === 'function')
				_value = columnData.formatter(_value)

			return _value
		},
		//---------------------------------------------------------------------
		// установка успешного сообщения
		//---------------------------------------------------------------------
		setLocalSuccessMessage(msg) {
			EventBus.$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			})
		},
		//---------------------------------------------------------------------
		// запрос на удаление записи
		//---------------------------------------------------------------------
		askForDelete(Row) {
			if (!Row || !(this.idColumns in Row)) return
			if (!this.canAction('delete', Row)) return

			this.deleteId = Row[this.idColumns]
			let _name = this.deleteId

			if (this.crud === 'dns-records')
			{
				_name = 'main/record «' + Row['dns_type'] + '»:<br>'
				if (Row['dns_value'].length > 100) _name += Row['dns_value'].substr(0, 100) + '...'
				else _name += Row['dns_value']
			}

			if (this.crud === 'ipptrpool')
			{
				_name = 'main/for «' + Row['ptr_address'] + '» main/record:<br>'
				if (Row['ptr_host'].length > 100) _name += Row['ptr_host'].substr(0, 100) + '...'
				else _name += Row['ptr_host']
			}

			this.deleteModalText = this.localeFtc('main/delete_msg').replace('{name}', this.localeFtc(_name))

			if (this.isInnerForms)
			{
				this.$emit('title', 'ipptrpool/delete')
				this.$emit('containerClass', '')
				this.canShowButton = true
				this.innerFormErrorMessage = ''
				this.currentMode = 'delete'
				return
			}

			this.showDeleteModal = true
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог удаления записи
		//---------------------------------------------------------------------
		hideDeleteModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showDeleteModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// удаление записи
		//---------------------------------------------------------------------
		deleteModalStart() {
			// в любом случае - закрываем диалог
			this.hideDeleteModal()

			// еще раз проверим доступ
			if (!this.Access)
			{
				this.$emit('error', 'main/access_denied')
				return
			}
			if (!this.isAccess(this.crud + '/delete'))
			{
				this.$emit('error', 'main/access_denied')
				return
			}

			// если нет ID объекта
			let _id = this.deleteId
			if (!_id)
			{
				this.$emit('error', 'main/object_id')
				return
			}

			// скрываем все кнопки
			this.canShowButton = false

			// делаем запрос на удаление - формируем URL
			let _url = this.APIServerUrl + '/'
			if (this.crud === 'dns-records') _url += 'dns'
			else _url += this.crud
			_url += '/delete/' + _id

			// первый запрос - GET
			this.$http.get(_url).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// второй запрос - POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.canShowButton = true

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// запросим данные
									this.requestData()
									// на этом все
									return
								}

								// иная ошибка
								this.$emit('error', this.formatRequestError(resPost))
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.canShowButton = true
								// ошибка
								this.$emit('error', this.formatRequestError(resPost))
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.canShowButton = true
					// ошибка получения CSRF-кода
					this.$emit('error', this.formatRequestError(resGet))
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.canShowButton = true
					this.$emit('error', this.formatRequestError(resGet))
				}
			)
		},
		//---------------------------------------------------------------------
		// удаление записи
		//---------------------------------------------------------------------
		deleteInnerForms() {
			if (!this.isInnerForms) return
			if (!this.canShowButton) return

			this.innerFormErrorMessage = ''

			// еще раз проверим доступ
			if (!this.Access)
			{
				this.innerFormErrorMessage = 'main/access_denied'
				return
			}
			if (!this.isAccess(this.crud + '/delete'))
			{
				this.innerFormErrorMessage = 'main/access_denied'
				return
			}

			// если нет ID объекта
			let _id = this.deleteId
			if (!_id)
			{
				this.innerFormErrorMessage = 'main/object_id'
				return
			}

			// скрываем все кнопки
			this.canShowButton = false

			// делаем запрос на удаление - формируем URL
			let _url = this.APIServerUrl + '/'
			if (this.crud === 'dns-records') _url += 'dns'
			else _url += this.crud
			_url += '/delete/' + _id

			// первый запрос - GET
			this.$http.get(_url).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// второй запрос - POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.canShowButton = true

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// запросим данные
									this.requestData(() => {
										this.$emit('containerClass', 'wide')
										this.currentMode = 'list'
										this.$emit('refresh')
									})
									// на этом все
									return
								}

								// иная ошибка
								this.innerFormErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.canShowButton = true
								// ошибка
								this.innerFormErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.canShowButton = true
					// ошибка получения CSRF-кода
					this.innerFormErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.canShowButton = true
					this.innerFormErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// можно удалить или редактировать
		//---------------------------------------------------------------------
		canAction(action, row) {
			// разрешение от родителя
			if (!this.Access) return false

			// разрешение на операцию
			if (!this.isAccess(this.crud + '/' + action)) return false

			// флаг в записи
			let _act = 'can_' + action
			if (!(_act in row)) return true

			return row[_act]
		},
		//---------------------------------------------------------------------
		// обработка клика по кнопке операции
		//---------------------------------------------------------------------
		buttonClicked(e) {
			// запоминаем текущую страницу
			this.$store.commit('tableCurrentPage', this.page)
			// если конопки показаны - все ок
			if (this.canShowButton) return
			// иначе - не передаем клик дальше
			e.preventDefault()
		},
		//---------------------------------------------------------------------
		// функция устанавливает размер страницы
		//---------------------------------------------------------------------
		setPageSize(size) {
			// если это тот же размер
			if (size === this.Data.pageSize) return
			// если какой то левый размер
			if (this.Config.pageSizes.indexOf(size) === -1) return
			// можно делать запрос
			let _params = {
				'additional': 'setPageSize',
				'size': size,
				'dontAbort': true
			}
			this.forms_Get('/user/index', _params,
				(data) => {
					if (!data || data['status'] !== 'ok') this.$emit('error', this.localeFtc('register/error'))
					this.requestData()
				},
				() => this.requestData()
			)
		},
		//---------------------------------------------------------------------
		// установка текущей страницы
		//---------------------------------------------------------------------
		setCurrentPage(page) {
			if (!page || !this.page || page === this.page) return
			if (page > this.lastPage) return
			if (this.paginationPages.length <= 1) return

			this.page = page
			this.requestData()
		},
		//---------------------------------------------------------------------
		// установка значения быстрого поиска
		//---------------------------------------------------------------------
		setFastSearchValue(value) {
			this.fastSearchValue = value
			setTimeout(() => {
				EventBus.$emit('w5-set-text-field-value', {
					'name': 'fastSearch',
					'value': value
				})
			}, 100)
		},
		//---------------------------------------------------------------------
		// обработчик изменения поля быстрого поиска
		//---------------------------------------------------------------------
		fastSearchEvent(text) {
			// проверка параметра
			if (text === undefined || text === null || text === '')
			{
				// когда обнуляют поиск - сразу делаем запрос
				this.setFastSearchValue('')
				this.requestData()
				return
			}

			// обновляем модель
			this.setFastSearchValue(text)
			// начинаем поиск только при определенных условиях
			let _canRequest = false
			// если есть глобальный фильтр
			if (this.$store.state.accountGlobalFilter === true)
			{
				// можно запрашивать данные в любом случае
				_canRequest = true
			}
			else
			{
				// иначе только при определенных условиях
				if (this.$store.state.user_type !== 'admin')
				{
					// клиенту можно вводить минимум 2 символа
					if (String(text).length >= 2) _canRequest = true
				}
				else
				{
					// сотруднику минимум 3 символа
					if (String(text).length >= 3) _canRequest = true
				}
			}

			// если флаг положительный - делаем запрос
			if (_canRequest) this.requestData()
		},
		//---------------------------------------------------------------------
		// сортировка таблицы
		//---------------------------------------------------------------------
		sortTable(field) {
			// двухзначный переключатель
			if (this.sortedColumn === false) this.sortedColumn = '-' + field
			else if (this.sortedColumn === '+' + field || this.sortedColumn === field) this.sortedColumn = '-' + field
			else if (this.sortedColumn === '-' + field) this.sortedColumn = '+' + field
			else this.sortedColumn = '-' + field

			this.requestData()
		},
		//---------------------------------------------------------------------
		// функция возвращает класс ячейки
		//---------------------------------------------------------------------
		cellClass(field) {
			let _class = ''
			let _sortedCell = false

			// если установлена какая то сортировка
			if (this.sortedColumn)
			{
				_sortedCell = this.sortedColumn.indexOf(field) >= 0
			}
			// пользователь не устанавливал сортировку
			else
			{
				// может есть сортировка по умолчанию - и это она?
				if (this.Data && this.Data.defaultSort)
					_sortedCell = this.Data.defaultSort.indexOf(field) >= 0
			}

			// если в итоге поле отсортировано - добавим соответствующий класс
			if (_sortedCell) _class = 'w5-table-cell-sorted'

			// возвращаем
			return _class
		},
		//---------------------------------------------------------------------
		// есть ли видимые поля в строке
		//---------------------------------------------------------------------
		isVisibleField(row) {
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// количество видимых полей в строке
		//---------------------------------------------------------------------
		countVisibleFieldsInRow(row) {
			// ответ по умолчанию
			let _answer = 0
			// ищем все видимые поля
			row.forEach(item => {
				if (item && item.type !== 'hidden' && item['_visible'] === true)
				{
					_answer++
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// поменялось значение поля
		//---------------------------------------------------------------------
		fieldChanged(field) {
			// каждый раз вычисляем условия "showif" для всех полей с таким условием
			this.showif()
		},
		//---------------------------------------------------------------------
		// вычисляем значение "showif" для всех полей
		//---------------------------------------------------------------------
		showif() {
			// бежим по всем полям
			let _rows = this.innerFormData['fields']
			if (!_rows || !Array.isArray(_rows)) return

			// готовим объекты, где собираем значения и выражения
			let _values = {}
			let _expressions = {}

			// бежим по всем полям - собираем значения и выражения
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим только поля с названиями
						if (field['_field_name'])
						{
							// заполняем объект со значениями
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value']

							// если есть выражение для данного поля
							if (field['showif'])
							{
								// получим выражение
								let _expr = field['showif']
								// подменяем в выражении переменные
								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1)
								{
									// условие: var not in [array]
									if (_expr.indexOf(' not in ') !== -1)
									{
										// var not in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5]) < 0
										let reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0')
										}
										else
										{
											// var[idx] not in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5]) < 0
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') < 0')
											}
										}
									}
									// условие: var in [array]
									else
									{
										// var in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5])
										let reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) !== -1')
										}
										else
										{
											// var[idx] in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5])
											reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') !== -1')
											}
										}
									}
								}
								// type[period] == 0    =>    type__period__ == 0
								else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')
								_expressions[field['_field_name']] = _expr
							}
						}
					})
				}
			})

			// теперь бежим по всем полученным выражениям
			for (let e in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[e]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _field = this.findField(e)
				if (_field)
				{
					// обнулим ошибку в любом случае
					this.$set(_field, '_errMsg', '')
					// установим видимость поля
					this.$set(_field, '_visible', _func(_values))
				}
			}
		},
		//---------------------------------------------------------------------
		// фокус на поле
		//---------------------------------------------------------------------
		onFocus(field) {
			// чистим ошибку если есть
			field['_errMsg'] = ''
		},
		//---------------------------------------------------------------------
		// потеря фокуса полем
		//---------------------------------------------------------------------
		onBlur(field) {
			// если это уже сабмит формы - проверка не требуется
			if (this.isFormSubmited) return

			// проверка поля
			this.verifyField(field)
		},
		//---------------------------------------------------------------------
		// нажали ENTER по полю
		//---------------------------------------------------------------------
		onEnterKeyDown(e) {
			if (e) e.preventDefault()
			this.submitInnerForm(e)
		},
		//---------------------------------------------------------------------
		// проверка поля
		//---------------------------------------------------------------------
		verifyField(field) {
			// по умолчанию чистим сообщение об ошибке
			field['_errMsg'] = ''

			// если значение пустое или не задано - проверка не нужна
			if (field.value === undefined || field.value === null || String(field.value) === '') return

			// если есть флаг fake - проверка не нужна
			if (field.fake === true) return

			// если не прошли локальную проверку - ошибка уже записана в переменную
			if (!this.localValidation(field)) return

			// формируем значения для проверки на API-сервере
			let _obj = {}
			let o
			if (field.validate_with)
			{
				let _v = field.validate_with

				if (typeof _v === 'object' && Array.isArray(_v) && _v.length)
				{
					for (let _i in _v)
					{
						o = this.findField(_v[_i])
						// если нет значения в каком то поле из validate_with
						if (o && (o.value === undefined || o.value === null || String(o.value) === ''))
						{
							// если это булево поле - передаем значение false
							if (o.type === 'boolean')
								_obj[_v[_i]] = 0
							// проверять не нужно
							else
								return
						}
						if (o && o.value) _obj[_v[_i]] = o.value
						if (o && o.type === 'boolean') _obj[_v[_i]] = Helper.normalizeBooleanValue(o.value) ? 1 : 0
					}
				}
				else if (typeof _v === 'object')
				{
					for (let _i in _v) if (_v.hasOwnProperty(_i))
					{
						o = this.findField(_v[_i])
						// если нет значения в каком то поле из validate_with - проверять не нужно
						if (o && (o.value === undefined || o.value === null || String(o.value) === ''))
						{
							// если это булево поле - передаем значение false
							if (o.type === 'boolean')
								_obj[_v[_i]] = 0
							// проверять не нужно
							else
								return
						}
						if (o && o.value) _obj[_v[_i]] = o.value
						if (o && o.type === 'boolean') _obj[_v[_i]] = Helper.normalizeBooleanValue(o.value) ? 1 : 0
					}
				}
				else
				{
					o = this.findField(_v)
					// если нет значения в каком то поле из validate_with - проверять не нужно
					if (o && (o.value === undefined || o.value === null || String(o.value) === '')) return
					if (o && o.value) _obj[_v] = o.value
					if (o && o.type === 'boolean') _obj[_v] = Helper.normalizeBooleanValue(o.value) ? 1 : 0
				}
			}

			// формируем URL
			let _url = this.APIServerUrl + (this.currentMode === 'create' ? this.urlCreate : this.urlUpdate + this.updatedRowId)
			// обнулим хендлеры предыдущих запросов
			this.verifyRequestsHandlers = []
			// делаем запрос на проверку поля
			this.forms_verifyRequest(
				// URL запроса
				_url,
				// данные
				{
					'field': field['_field_name'],
					'value': field['value'],
					'data': _obj
				},
				// callback-функция
				(data) => {
					if (data && data['fields'] && data['fields'][field['_field_name']])
					{
						let _msg = data['fields'][field['_field_name']]
						if (typeof _msg === 'string')
						{
							field['_errMsg'] = _msg
							EventBus.$emit('w5-set-field-error')
						}
						else if (typeof _msg === 'object')
						{
							let _txt = ''
							for (let k in _msg)
								if (_txt === '') _txt = _msg[k]
								else _txt += ' <br> ' + _msg[k]
							field['_errMsg'] = _txt
							EventBus.$emit('w5-set-field-error')
						}
					}
				},
				// функция, которая запоминает хендлеры запросов - что бы их можно было терминировать
				(request) => {
					this.verifyRequestsHandlers.push(request)
				}
			)
		},
		//---------------------------------------------------------------------
		// локальная проверка полей
		//---------------------------------------------------------------------
		localValidation(field) {
			// проверяем только определенные типы
			// если поле невидно - то и проверять нет смысла, передаваться будет как есть
			if (!field['_visible']) return true
			// если значение поля не задано - то и проверять нет смысла, передаваться будет как есть
			if (field['value'] === undefined || field['value'] === null) return true

			// INTEGRE
			if (field.type === 'integer' || field.type === 'int')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в INT
				let r = parseInt(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_int'
					return false
				}

				// если значение не изменилось
				if (v === String(r)) return true
				// значение изменилось
				field['_errMsg'] = 'validators/error_int'
				return false
			}

			// FLOAT || MONEY
			if (field.type === 'float' || field.type === 'money')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в FLOAT
				let r = parseFloat(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_float'
					return false
				}

				// доп.проверка
				if (!Helper.isNumeric(String(r)))
				{
					// значение не число
					field['_errMsg'] = 'validators/error_float'
					return false
				}
			}

			// EMAIL
			if (field.type === 'email')
			{
				if (Helper.validateEmail(field.value)) return true
				// проверка не пройдена
				field['_errMsg'] = 'validators/error_email'
				return false
			}

			// для остальных типов все ОК
			return true
		},
		//---------------------------------------------------------------------
		// нужно заблокировать кнопку формы
		//---------------------------------------------------------------------
		blockFormButton() {
			if (this.buttonBlock > 0) return
			this.buttonBlock++
		},
		//---------------------------------------------------------------------
		// нужно разблокировать кнопку формы
		//---------------------------------------------------------------------
		unblockFormButton() {
			this.buttonBlock--
			if (this.buttonBlock < 0) this.buttonBlock = 0
		},
		//---------------------------------------------------------------------
		// это поле-разделитель?
		//---------------------------------------------------------------------
		isDividerField(row) {
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом "header"
			row.some((item, idx, arr) => {
				// если такое поле есть
				if (item && item.type === 'header' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// поиск поля в formData
		//---------------------------------------------------------------------
		findField(name) {
			// если нет вообще полей
			if (!this.innerFormData || !this.innerFormData.fields) return null

			// поля есть - пробежимся по ним
			let _field = null
			this.innerFormData.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		//---------------------------------------------------------------------
		// сбор данных для формы
		//---------------------------------------------------------------------
		collectData(rows) {
			// обнуляем данные
			let data = {}

			// смотрим каждое поле простым циклом - что бы прервать его в любой момент
			for (let idx in rows)
			{
				// если нет значения - пропускаем
				if (!rows[idx] || !Array.isArray(rows[idx])) continue

				// бежим по всей строке формы
				let row = rows[idx]
				for (let k in row)
				{
					// получим объект - поле
					let field = row[k]

					// рассматриваем только поля с наименованиями
					if (!field['_field_name']) continue

					// поля с флагом fake - пропускаем
					if (field['fake'] === true) continue

					// если есть хотя бы одно видимое поле с ошибкой - прерываем
					if (field['_errMsg'] && field['_visible'])
					{
						this.buttonBlock = 0
						return false
					}

					// значение по умолчанию
					let _val = field['value']

					// если это "file" или "image"
					if (field['type'] === 'file' || field['type'] === 'image')
					{
						// если есть метка удаления файла
						if (field['_deleteFile'] === true)
						{
							// добавляем еще параметр
							data[field['_field_name'] + '_delete'] = 1
						}

						// если это одиночное значение
						if (field['multifile'] !== true)
						{
							// если задан URl - значит ничего нового не задавали, не нужно пересылать это
							if (_val && (_val.indexOf('.') > -1 || _val.indexOf('/') > -1)) _val = null
						}
					}

					// если это массив
					if (Array.isArray(field['value']))
					{
						// если это пустой массив
						if (!field['value'].length) _val = null
						else
						{
							// масив имеет значения
							_val = []
							// бежим по нему, для конвертации
							field['value'].forEach(item => {
								// если элемент массива - это объект c id
								if (typeof item === 'object' && item['id'])
								{
									_val.push(item['id'])
								}
								// если простой тип
								else _val.push(item)
							})
						}
					}

					// обязательное поле?
					if (field['required'] === true && field['_visible'])
					{
						// если значение вообще не задано
						if (_val === undefined || _val === null)
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}

						// если это пустой массив
						if (Array.isArray(_val) && _val.length === 0)
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}
					}

					// локальная проверка
					if (!this.localValidation(field))
					{
						// сообщение уже записано
						this.buttonBlock = 0
						return false
					}

					// если пустые поля
					if (_val === undefined || _val === null)
					{
						// если это поле массива - все равно передаем
						if (/^\w+\[\w+\]/i.test(field['_field_name']))
							data[field['_field_name']] = ''
						// остальное игнорируем
						continue
					}

					// конвертация значения
					if (field['type'] === 'boolean')
						_val = Helper.normalizeBooleanValue(_val) ? 1 : 0

					// если это номер телефона
					if (field['type'] === 'text' && (field['_field_name'].indexOf('phone') > -1 || field['_field_name'].indexOf('[fax]') > -1))
					{
						// если стоит валидатор "phone"
						if (field['validator'] === 'phone')
						{
							// отправляем с форматированием
							// удалим остатки маски
							_val = String(_val).replace(/_/g, '')
							// есть ли в значении круглые скобки
							if (_val.indexOf('(') > -1 || _val.indexOf(')') > -1)
							{
								// собираем значение
								_val = _val.replace(/\(/g, ' ').replace(/\)/g, ' ').replace(/-/g, '')
							}
							else
							{
								// если нет скобок - просто заменяем первые два прочерка на пробелы
								_val = _val.replace('-', ' ')
								_val = _val.replace('-', ' ')
								// а остальные просто убираем
								_val = _val.replace(/-/g, '')
							}
						}
						else
						{
							// а иначе просто убираем лишние символы
							_val = String(_val).replace(/[()\s]/g, '')
						}
					}

					// если это дата с заданным форматом
					if (field['type'] === 'date' && field['format'])
					{
						// требуется преобразование
						_val = String(_val)
						if (/^\d{4}-\d{2}-\d{2}$/.test(_val) || /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val))
							_val = Helper.FormatDateTime(_val, field['format'])
					}

					// все проверки пройдены - запоминаем значение
					data[field['_field_name']] = _val
				}
			}

			// возвращаем полученный ответ
			return data
		},
		//---------------------------------------------------------------------
		// NameForm[data[disk]] => NameForm[data][disk]
		//---------------------------------------------------------------------
		FD_rePack(data) {
			let k
			let n1
			let n2
			let key1
			let key2

			for (k in data) if (data.hasOwnProperty(k))
			{
				n1 = k.indexOf('[')
				if (n1 < 0) continue

				n2 = k.indexOf(']', n1)
				if (n2 < 0) continue

				key1 = k.substr(0, n1)
				key2 = k.substring(n1 + 1, n2)

				if (n2 + 1 < k.length) key2 += k.substr(n2 + 1)

				if (!data[key1]) data[key1] = {}

				data[key1][key2] = data[k]

				delete data[k]

				data[key1] = this.FD_rePack(data[key1])
			}

			return data
		},
		//---------------------------------------------------------------------
		// конвертация данных в FormData
		//---------------------------------------------------------------------
		FD_prepare: function(d, key) {
			let k

			for (k in d) if (d.hasOwnProperty(k))
			{
				// если пересылают файл в форме - патч для safari 10+
				if (d[k] && key &&
					k === 'file' &&
					typeof d[k] === 'object' &&
					'name' in d[k] &&
					'size' in d[k] &&
					'type' in d[k])
				{
					this.FD.append(key + '[' + k + ']', d[k])
					this.FD_count++
					continue
				}

				// остальные поля обрабатываем по старому
				if (typeof d[k] === 'object' && d[k] && !('lastModifiedDate' in d[k]))
				{
					if (key)
					{
						this.FD_prepare(d[k], key + '[' + k + ']')
					}
					else
					{
						this.FD_prepare(d[k], k)
					}
				}
				else
				{
					if (key)
					{
						this.FD.append(key + '[' + k + ']', d[k])
					}
					else
					{
						this.FD.append(k, d[k])
					}

					this.FD_count++
				}
			}
		},
		//---------------------------------------------------------------------
		// показ формы создания/редактирования
		//---------------------------------------------------------------------
		showInnerForm(type, row) {
			this.currentMode = type
			this.innerFormErrorMessage = ''
			this.updatedRowId = ''

			if (type === 'update' && (!row || !row[this.idColumns])) return

			let _url = ''
			if (type === 'create') _url = this.urlCreate
			else if (type === 'update')
			{
				this.updatedRowId = row[this.idColumns]
				_url = this.urlUpdate + this.updatedRowId
			}

			// включаем лоадер
			this.$store.commit('needShowLoader', true)

			// производим сам запрос формы
			this.forms_Get(_url, false,
				// успешно получили данные
				(data) => {
					// нужно распарсить поля формы
					this.innerFormData = this.parseFormData(data)
					if (this.innerFormData && typeof this.innerFormData === 'object')
					{
						// заголовок
						if (this.inModal && this.innerFormData.title)
						{
							this.$emit('title', this.innerFormData.title)
						}
						// csrf код
						this.innerFormData.csrf = data._csrf
					}
				},
				// неудача
				() => {
					// включаем лоадер обратно
					this.$store.commit('needShowLoader', true)

					// ошибка
					let _errMsg = this.localeFtc('error/http_error')
					if (this.form_ErrorMessage) _errMsg = this.form_ErrorMessage

					this.innerFormErrorMessage = _errMsg
				}
			)
		},
		//---------------------------------------------------------------------
		//
		//---------------------------------------------------------------------
		submitInnerForm(e) {
			this.innerFormErrorMessage = ''

			let _rows = this.innerFormData['fields']
			// если полей нет
			if (!_rows || !Array.isArray(_rows))
			{
				this.innerFormErrorMessage = 'error/app_internal'
				this.buttonBlock = 0
				return
			}

			let _data = this.collectData(_rows)
			// если данные по каким либо причинам собрать не удалось
			if (_data === false)
			{
				return
			}

			// включаем лоадер
			this.$store.commit('needShowLoader', true)

			// сразу лочим кнопку
			if (this.buttonBlock <= 0) this.buttonBlock = 1

			// url
			let _url = ''
			if (this.currentMode === 'create') _url = this.urlCreate
			else if (this.currentMode === 'update')
			{
				_url = this.urlUpdate + this.updatedRowId
			}

			// переупакуем данные: NameForm[data[disk]] => NameForm[data][disk]
			_data = this.FD_rePack(_data)

			// готовим данные
			let _post = {
				'_csrf': this.innerFormData.csrf
			}
			_post[this.innerFormData.model] = _data

			// готовим данные в виде FormData
			this.FD = new FormData()
			this.FD_count = 0
			this.FD_prepare(_post)

			// если есть запросы - проверки полей, их нужно терминировать
			if (this.verifyRequestsHandlers && this.verifyRequestsHandlers.length)
			{
				this.verifyRequestsHandlers.forEach(item => {
					if (item && item.abort)
						item.abort()
				})

				this.verifyRequestsHandlers = []
			}

			// производим сам запрос
			this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null)
			.then(
				// успешный ответ сервера
				resPost => {
					// выключаем лоадер
					this.$store.commit('needShowLoader', false)

					// данные
					let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
					// если ошибки нет
					if (_dt && _dt['status'] === 'ok')
					{
						// нужно самим запросить данные
						this.requestData(() => {
							this.buttonBlock = 0
							this.currentMode = 'list'
							this.$emit('refresh')
						})
						return
					}

					// если есть ошибки и поля
					if (_dt && _dt['status'] === 'error' && _dt['fields'])
					{
						let _txtError = ''
						// бежим по всем полям
						for (let k in _dt['fields'])
						{
							if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length)
							{
								// ищем поле, для которого указана ошибка
								let _fld = this.findField(k)
								// если такое поле есть - ставим все сообщения
								if (_fld)
								{
									_fld['_errMsg'] = this.localeFtc(_dt['fields'][k].join(' <br> '))
									EventBus.$emit('w5-set-field-error')
								}
								else
								{
									let _m = k.match(/^params\[(.*)\]$/i)
									if (_m && _m.length && _m[1])
									{
										_txtError += String(_m[1]).toUpperCase() + ': ' + this.localeFtc(_dt['fields'][k].join(' <br> '))
									}
									else _txtError += this.localeFtc(_dt['fields'][k].join(' <br> '))
								}
							}
						}
						if (_txtError) this.innerFormErrorMessage = _txtError
						// на этом все
						this.buttonBlock = 0
						return
					}
					// иная ошибка
					this.innerFormErrorMessage = this.formatRequestError(resPost)
					this.buttonBlock = 0
				},
				// отрицательный ответ сервера
				resPost => {
					// выключаем лоадер
					this.$store.commit('needShowLoader', false)

					// ошибка
					this.innerFormErrorMessage = this.formatRequestError(resPost)
					this.buttonBlock = 0
				}
			)
		}
		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатели
	//=========================================================================
	watch: {
		'access': function(value) {
			this.Access = value
		},
		'currentMode': function(value) {
			this.$emit('currentMode', value)
		}
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.table-component-root {
	min-height: 190px;
}

.search-wrapper {
	margin: 10px 0;
}

.table-wrapper {
	margin: 20px 0;
	width: 100%;
}

.table-wrapper.inner-forms {
	margin-top: 5px;
}

td, th {
	font-size: 12px;
	padding: 2px 4px;
}

th.column-oper {
	width: 60px;
}

.btn {
	font-size: 14px;
    font-weight: 500;
}

svg.fa-pencil-alt {
	font-size: 14px;
	color: #2880da;
	cursor: pointer;
	margin-left: 10px;
}
.w5-application.mc svg.fa-pencil-alt {
	color: #3250ba;
}
svg.fa-trash-alt {
	font-size: 14px;
	color: red;
	cursor: pointer;
	margin-left: 10px;
}

.modal-body > p {
	margin: 0;
	padding: 0;
	word-break: break-word;
}

.pagination {
	font-size: 12px;
}

.pagination > li > span {
	cursor: pointer;
}

.pagination > li > span.active {
	background-color: #2c8ad8;
    border-color: #2c8ad8;
    color: white;
}

.pagination > li > span.active:hover {
	z-index: 0;
}

table .w5-table-cell {
	white-space: normal;
    word-break: break-word;
}

.w5-form-del-row {
	padding: 15px;
	margin: 0 -15px 15px -15px;
	border-bottom: 1px solid #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// table.vue?3d7d0fe0